import {
  mediaQueryLarge,
  requestIdleCallback,
  startViewTransition,
} from "@theme/utilities";
import PaginatedList from "@theme/paginated-list";
import { sectionRenderer } from "@theme/section-renderer";

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener("change", this.#handleMediaQueryChange);
    this.setAttribute("initialized", "");
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener("change", this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ["product-grid"]);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? "desktop" : "mobile";
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute("product-grid-view", value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout("default");
  };

  /**
   * Switches the search results type.
   *
   * @param {Event} event
   */
  switchSearchResultsType(event) {
    //console.log("switchSearchResultsType", event);
    const { target } = event;

    if (!(target instanceof HTMLButtonElement)) return;
    const searchType = target.getAttribute("data-search-type");
    if (!searchType || !this.sectionId) return;
    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set("q", this.dataset.searchTerm || "");
    url.searchParams.set("type", searchType);
    window.location.href = url.toString();

    /*
        const selectedTab = this.querySelector('.search-results-types--item.selected');
        if (selectedTab) selectedTab.classList.remove('selected');
        target.classList.add('selected');
        this.dataset.activeType = searchType;*/
  }
}

if (!customElements.get("results-list")) {
  customElements.define("results-list", ResultsList);
}
